module.exports = __webpack_public_path__ + "static/photo_4-48dfeb931c0f75e57c1c26474624a804.jpg";